import React from 'react';
import { render } from 'react-dom';
import CurrencyFormat from 'react-currency-format';

class WbmCurrencyFormat extends React.Component {
    render() {
        return (
            <CurrencyFormat value={this.props.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
        );
    }
}
export default WbmCurrencyFormat;  